import Command from '@ckeditor/ckeditor5-core/src/command';
import { isCustomButtonElement } from '../utils';

export default class CustomButtonLinkCommand extends Command {
	override refresh() {
		const element = this.editor.model.document.selection.getSelectedElement()!;

		this.isEnabled = isCustomButtonElement( element );

		if ( isCustomButtonElement( element ) && element.hasAttribute( 'href' ) ) {
			this.value = element.getAttribute( 'href' );
		} else {
			this.value = false;
		}
	}

	override execute( options: {newValue: string} ) {
		const model = this.editor.model;
		const customButtonElement = model.document.selection.getSelectedElement()!;

		model.change( writer => {
			writer.setAttribute( 'href', options.newValue, customButtonElement );
		} );
	}
}

